define('views/reservations/reservations',[
    'backbone',
    'views/_base/baseview',
    'text!views/reservations/reservations.html',
    'views/shared/tab/tab_component',
    'views/reservations/reservation',
    'models/securecontent/securecontent'
], function(Backbone, BaseView, Template, TabComponent, Reservation, SecureContent){
    'use strict';

    return BaseView.extend({
        className: 'profile-content',
        tagName  : 'div',
        isRender : true,
        template : _.template(Template),
        events   : {},

        initialize: function(options){
            options = options || {};

            this.tab_component = {};
            
            this.upcoming_reservation_content = [];
            this.past_reservation_content = [];

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            this.tab_component = new TabComponent({
                elementName: '.js-reservations-tab-component',
                context    : this,
                tabs       : [
                    {
                        name    : 'Upcoming Trips',
                        tab_id  : 'upcoming',
                        panel_id: 'upcoming'
                    },
                    {
                        name    : 'Past Trips',
                        tab_id  : 'past',
                        panel_id: 'past'
                    }
                ],
                tab_panels : [
                    {
                        list      : true,
                        list_class: 'reservations-list',
                        content   : null,
                        view_class: Reservation,
                        panel_id  : 'upcoming',
                        events    : {
                            show: function(){
                                that.getUpcomingReservations();
                            }
                        }
                    },
                    {
                        list      : true,
                        list_class: 'reservations-list',
                        content   : null,
                        view_class: Reservation,
                        panel_id  : 'past',
                        events    : {
                            show: function(){
                                that.getPastReservations();
                            }
                        }
                    }
                ]
            });

            return this;
        },

        loadData: function(){},

        getUpcomingReservations: function(){
            var that = this;

            this.upcoming_reservation_content = [];

            // Get upcoming reservations
            this.getReservations({
                status: '1,2,3,4,5',
                past  : false,
                future: true
            }, this.upcoming_reservation_content, function(){

                if(that.upcoming_reservation_content.length == 0){
                    var content = 'No reservations found';
                } else {
                    var content = that.upcoming_reservation_content;
                }

                // Sending the panel_id and content as params
                that.tab_component.reloadPanel('upcoming', content);
            });

        },

        getPastReservations: function(){
            var that = this;

            this.past_reservation_content = [];

            // Get past reservations
            this.getReservations({
                status: '1,2,3,4,5',
                past  : true,
                future: false
            }, this.past_reservation_content, function(){

                if(that.past_reservation_content.length == 0){
                    var content = 'No reservations found';
                } else {
                    var content = that.past_reservation_content;
                }

                // Sending the panel_id and content as params
                that.tab_component.reloadPanel('past', that.past_reservation_content);
            });

        },

        getReservations: function(data, reservation_list, callback){

            // NOTE: Keeping this here because we want to eventually use this method of requesting reservation data

            // pf.apigconfig.reservations.endpointPath = '/v1/reservations/hotels?status=' + data.status + '&past=' + data.past + '&future=' + data.future;

            // var that = this,
            //     config = pf.apigconfig.reservations,
            //     body = {
            //         origin  : window.location.href,
            //         userGUID: pf.session.get('UserGUID'),
            //         // userGUID: 'b96768ab95a14db19d0fb003b86d36c1',
            //         data    : data
            //     };

            // var secure_content = new SecureContent({ requestBody: body, config: config });

            // secure_content.postContent(function(error, body){

            //     // console.log('getReservations',data,body);

            //     if(!error){

            //         var reservations = body.data;
            //         // Format the reservation data before showing
            //         that.formatReservations(reservations, reservation_list);

            //     }

            //     if(_.isFunction(callback)){
            //         callback();
            //     }
                
            // });

            var that = this;

            $.ajax({
                type       : 'GET',
                url        : pf.url + '/v1/reservations/hotels',
                contentType: 'application/json',
                data       : data,
                success    : function(data, status, options){

                    var reservations = data;

                    // Format the reservation data before showing
                    if(reservations){
                        that.formatReservations(reservations, reservation_list);
                    }

                    if(_.isFunction(callback)){
                        callback();
                    }

                },
                error: function(data, status, options){

                    console.log('error', data, status, options);
                    
                }
            });

        },

        formatReservations: function(reservations, reservation_list){
            var that = this;

            reservations.forEach(function(reservation){

                reservation_list.push({
                    data     : reservation,
                    date     : moment.utc(reservation.checkin_date).format('MMM D, YYYY') + ' - ' + moment.utc(reservation.checkout_date).format('MMM D, YYYY'),
                    name     : reservation.merchant_name,
                    location : reservation.city + ', ' + reservation.state,
                    className: 'reservation'
                });

            });

        },

        close: function(){}
    });
});

